module.exports = __webpack_public_path__ + "static/Logo kannada - yuva-550b85f3e330e9a3e2cf77f25f1dc7ef.png";